import { PractitionerView } from '@dreryk/egabinet-personnel-frontend-api';
import {
   DayOfWeek,
   TherapeuticGroupIssue,
   TherapeuticGroupOccupancy,
   TherapeuticGroupStatus,
   TherapeuticGroupType,
   TimeOfDay,
} from '@dreryk/egabinet-group-session-frontend-api';

import { HealthcareProviderLocation } from '~libs.shared.healthcare-provider-location';

import { ServicesControllerItem } from './controllers/servicesController/ServicesController.types';

export type GroupSessionsFilterPanelSchedule = {
   dayOfWeek: DayOfWeek | null;
   timesOfDay: TimeOfDay[];
};

export type GroupSessionsFilterPanelFormBean = {
   healthcareProviderLocations: HealthcareProviderLocation[];
   practitioners: PractitionerView[];
   statuses: TherapeuticGroupStatus[];
   services: ServicesControllerItem[];
   scheduleDayOfWeek: DayOfWeek | null;
   scheduleTimesOfDay: TimeOfDay[];
   groupTypes: TherapeuticGroupType[];
   occupancy: TherapeuticGroupOccupancy | null;
   issue: TherapeuticGroupIssue | null;
};

export enum GroupSessionsFilterPanelSearchParam {
   HEALTHCARE_PROVIDER_LOCATION = 'mus',
   PRACTITIONER = 'specjalista',
   STATUS = 'status',
   SERVICES = 'usluga',
   SCHEDULE_DAY_OF_WEEK = 'dzien',
   SCHEDULE_TIMES_OF_DAY = 'pora-dnia',
   GROUP_TYPE = 'rodzaj',
   OCCUPANCY = 'oblozenie',
   ISSUE = 'uwaga',
}

export enum GroupSessionsFilterPanelStorageKey {
   HEALTHCARE_PROVIDER_LOCATION = 'healthcareProviderLocations',
   PRACTITIONER = 'practitioners',
   STATUS = 'status',
   SERVICES = 'services',
   SCHEDULE_DAY_OF_WEEK = 'dayOfWeek',
   SCHEDULE_TIMES_OF_DAY = 'timesOfDay',
   GROUP_TYPE = 'groupTypes',
   OCCUPANCY = 'occupancy',
   ISSUE = 'issue',
}
